const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the manager dashboard component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('graderDashboard', ['Authorization', 'AssessmentScores', function (Authorization, AssessmentScores) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      isManager: '@'
    },
    template: require('../../../templates/directives/assessments/grader-dashboard.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.user = Authorization.getAuthToken().user;

      self.info = {
        loading: false,
        allowNext: false,
        activeScore: null,
        showGradeScore: false,
        scores: [],
        query: {
          page: 1,
          per_page: 20,
          fields: 'company,assessment,awaiting_manual_grade,user',
          'assessment-populate': 'title',
          'user-populate': 'first_name,last_name,full_name,email,linked_locations,linked_departments',
          'user.linked_departments-populate': 'name',
          'user.linked_locations-populate': 'name'
        },
        getLocation: function(user) {
          if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
            return user.linked_locations[0].name;
          }
          return '-----';
        },
        getDepartment: function(user) {
          if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
            return user.linked_departments[0].name;
          }
          return '-----';
        },
        grade: function(score) {
          if (!score || !score._id) {
            return;
          }
          self.info.activeScore = score._id;
          self.info.showGradeScore = true;
        }
      };

      self.comms = {
        loadManager: function() {
          // Get scores for managers and for 
          var opts = Object.assign({subname: self.user.email}, self.info.query);
          return AssessmentScores.findByManager(opts).$promise
        },
        loadGrader: function() {
          var opts = Object.assign({subname: self.user._id}, self.info.query);
          return AssessmentScores.findByGrader(opts).$promise
        },
        loadSpecific: function() {
          if ($scope.isManager) {
            return self.comms.loadManager();
          }
          return self.comms.loadGrader();
        },
        load: function(denied) {
          self.info.loading = true;
          self.comms.loadSpecific()
          .then(function(results) {
            self.info.allowNext = denied ? false : true;
            if (!results || results.length < self.info.query.per_page) {
              self.info.allowNext = false;
              if (!results.length && self.info.query.page > 1) {
                self.info.query.page--;
                self.comms.load(true);
                return;
              }
            }
            self.info.scores = results;
            self.info.loading = false;
          }).catch(function(error) {
            self.info.loading = false;
            console.log('error: ', error);
          });
        },
        nextPage: function() {
          if (!self.info.allowNext || self.info.scores.length < self.info.query.per_page) {
            return;
          }
          self.info.query.page++;
          self.comms.load();
        },
        previousPage: function() {
          if (self.info.query.page < 2) {
            return;
          }
          self.info.query.page--;
          self.comms.load();
        },
        closeGrade: function(completed) {
          self.info.showGradeScore = false;
          self.info.activeScore = null;
          if (completed) {
            self.comms.load();
          }
        }
      };

      self.comms.load();
    }],
    controllerAs: 'grader'
  };
}]);